import { MatTooltipModule } from '@angular/material/tooltip';
import * as i0 from '@angular/core';
import { Directive, Injectable, Pipe, TemplateRef, Component, ChangeDetectionStrategy, Input, ViewChild, ContentChild, NgModule } from '@angular/core';
import * as i7 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i5 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import * as i3 from '@firestitch/list';
import { FsListModule } from '@firestitch/list';
import * as i6 from '@firestitch/skeleton';
import { FsSkeletonModule } from '@firestitch/skeleton';
import * as i2 from '@firestitch/message';
import { FsMessageModule } from '@firestitch/message';
import { of } from 'rxjs';

class FsImportConfigFooterDirective {
}
FsImportConfigFooterDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsImportConfigFooterDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FsImportConfigFooterDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: FsImportConfigFooterDirective, selector: "[fsImportConfigFooter]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsImportConfigFooterDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsImportConfigFooter]'
                }]
        }] });

class FsImportResultFooterDirective {
}
FsImportResultFooterDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsImportResultFooterDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FsImportResultFooterDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: FsImportResultFooterDirective, selector: "[fsImportResultFooter]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsImportResultFooterDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsImportResultFooter]'
                }]
        }] });

class FsImportService {
    constructor() { }
    setIterableConfigFields(fields) {
        for (const field of fields) {
            const validators = [];
            for (const key in field.validations) {
                if (!field.validations[key]) {
                    continue;
                }
                validators.push({ key: key, value: field.validations[key] });
            }
            field.validationsArray = validators;
        }
    }
}
FsImportService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsImportService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
FsImportService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsImportService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsImportService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

var ImportMode;
(function (ImportMode) {
    ImportMode["Processing"] = "processing";
    ImportMode["Result"] = "result";
    ImportMode["Config"] = "config";
})(ImportMode || (ImportMode = {}));

class KeysPipe {
    transform(value, args = null) {
        return Object.keys(value); //.map(key => value[key]);
    }
}
KeysPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: KeysPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
KeysPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: KeysPipe, name: "keys", pure: false });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: KeysPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'keys', pure: false }]
        }] });

class FsImportComponent {
    constructor(fsImportService, fsMessage, cdRef) {
        this.fsImportService = fsImportService;
        this.fsMessage = fsMessage;
        this.cdRef = cdRef;
        this.config = null;
        this.result = null;
        this.configFields = [];
        this.resultHasError = false;
        this.loaded = false;
        this.ImportMode = ImportMode;
        this._mode = ImportMode.Config;
        this.listConfigEl = null;
        this.listConfig = null;
        this.listResultEl = null;
        this.listResult = null;
        this.configTemplate = null;
        this.resultTemplate = null;
        this.$import = null;
    }
    get mode() {
        return this._mode;
    }
    ngOnInit() {
        this.config()
            .subscribe((response) => {
            this.fsImportService.setIterableConfigFields(response.fields);
            this.configFields = response.fields;
            this.loaded = true;
            this.cdRef.markForCheck();
        });
        this.listConfig = {
            status: false,
            paging: false,
            fetch: query => {
                return of({ data: this.configFields });
            }
        };
        this.listResult = {
            status: false,
            paging: false,
            fetch: query => {
                return of({ data: this.result.messages });
            }
        };
    }
    import(import$) {
        this._mode = ImportMode.Processing;
        this.resultHasError = false;
        this.$import = import$
            .subscribe(result => {
            this.result = result;
            this.resultHasError = !!(this.result.duplicate.count || this.result.fail.count);
            this._mode = ImportMode.Result;
            if (this.listResultEl) {
                this.listResultEl.reload();
            }
            this.cdRef.markForCheck();
        }, response => {
            this._mode = ImportMode.Config;
            this.fsMessage.error(response.error.message);
            this.cdRef.markForCheck();
        });
    }
    reset() {
        this.result = null;
        this._mode = ImportMode.Config;
        this.resultHasError = false;
        this.cdRef.markForCheck();
    }
    cancel() {
        if (this.$import) {
            this.reset();
            this.$import.unsubscribe();
        }
    }
}
FsImportComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsImportComponent, deps: [{ token: FsImportService }, { token: i2.FsMessage }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
FsImportComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsImportComponent, selector: "fs-import", inputs: { config: "config", hidePreviewColumn: "hidePreviewColumn" }, queries: [{ propertyName: "configTemplate", first: true, predicate: FsImportConfigFooterDirective, descendants: true, read: TemplateRef }, { propertyName: "resultTemplate", first: true, predicate: FsImportResultFooterDirective, descendants: true, read: TemplateRef }], viewQueries: [{ propertyName: "listConfigEl", first: true, predicate: ["listConfigEl"], descendants: true, static: true }, { propertyName: "listResultEl", first: true, predicate: ["listResultEl"], descendants: true, static: true }], ngImport: i0, template: "<div *fsSkeleton=\"loaded\">\n  <div *ngIf=\"mode === ImportMode.Config\">\n    <fs-list [config]=\"listConfig\" #listConfigEl>\n      <fs-list-column>\n        <ng-template fs-list-header>Column</ng-template>\n        <ng-template fs-list-cell let-row=\"row\">\n          {{ row.name }} <div class=\"smaller description\">{{ row.description }}</div>\n        </ng-template>\n      </fs-list-column>\n      <fs-list-column align=\"center\">\n        <ng-template fs-list-header>Required</ng-template>\n        <ng-template fs-list-cell let-row=\"row\" width=\"1%\">\n          <mat-icon class=\"required\" *ngIf=\"row.validations && row.validations.required\">check</mat-icon>\n        </ng-template>\n      </fs-list-column>\n      <fs-list-column>\n        <ng-template fs-list-header>Validations</ng-template>\n        <ng-template fs-list-cell let-row=\"row\">\n\n          <ng-container *ngFor=\"let key of row.validations | keys\">\n            <span *ngIf=\"key == 'values'\">\n              <div>Valid values</div>\n              <table class=\"values-table\">\n                <tr *ngFor=\"let value of row.validations['values']['array']\">\n                    <td class=\"smaller\">{{value}}</td>\n                </tr>\n              </table>\n            </span>\n            <span *ngIf=\"key == 'email'\">Valid email address</span>\n            <span *ngIf=\"key == 'date'\">Valid date\n              <div class=\"smaller\">Format: YYYY-MM-DD</div>\n            </span>\n            <span *ngIf=\"key == 'time'\">Valid time\n                <div class=\"smaller\">Format: HH:MM:SS</div>\n            </span>\n            <span *ngIf=\"key == 'int'\">Valid integer</span>\n            <span *ngIf=\"key == 'datetime'\">Valid date &amp; time\n              <div class=\"smaller\">Format: YYYY-MM-DD HH:MM:SS+ZZ:ZZ</div>\n            </span>\n            <span *ngIf=\"row.validations[key]['description']\">{{row.validations[key]['description']}}</span>\n          </ng-container>\n        </ng-template>\n      </fs-list-column>\n    </fs-list>\n\n    <p>\n      <ng-template\n        [ngTemplateOutlet]=\"configTemplate\"\n        [ngTemplateOutletContext]=\"{}\"\n      ></ng-template>\n    </p>\n  </div>\n\n  <div *ngIf=\"mode === ImportMode.Result\">\n    <fs-message\n      *ngIf=\"result.success.count\"\n      fsType=\"success\"\n      fsMessage=\"{{ result.success.message ? result.success.message : result.success.count + ' Successfully imported' }}\">\n    </fs-message>\n\n    <fs-message\n      *ngIf=\"result.duplicate.count\"\n      fsType=\"info\"\n      fsMessage=\"{{\n        result.duplicate.message ?\n        result.duplicate.message :\n        result.duplicate.count + ' Duplicate' + (result.duplicate.count === 1 ? '' : 's') + ' skipped' }}\">\n    </fs-message>\n\n    <fs-message\n      *ngIf=\"result.fail.count\"\n      fsType=\"error\"\n      fsMessage=\"{{ result.fail.message ? result.fail.message : result.fail.count + ' Failed to import' }}\">\n    </fs-message>\n\n    <div *ngIf=\"resultHasError\">\n      <fs-list [config]=\"listResult\" #listResultEl>\n        <fs-list-column align=\"center\" width=\"1%\">\n          <ng-template fs-list-header>Row</ng-template>\n          <ng-template fs-list-cell let-row=\"row\">\n            {{ row.row }}\n          </ng-template>\n        </fs-list-column>\n        <fs-list-column *ngIf=\"!hidePreviewColumn\">\n          <ng-template fs-list-header>Preview</ng-template>\n          <ng-template fs-list-cell let-row=\"row\">\n            {{ row.preview }}\n          </ng-template>\n        </fs-list-column>\n        <fs-list-column>\n          <ng-template fs-list-header>Reason</ng-template>\n          <ng-template fs-list-cell let-row=\"row\">\n            <div class=\"resason\">\n              <mat-icon *ngIf=\"row.type==='fail'\" class=\"icon-message\" [ngClass]=\"['icon-message-' + row.type ]\">report_problem</mat-icon>\n              <mat-icon *ngIf=\"row.type==='duplicate'\" class=\"icon-message\" [ngClass]=\"['icon-message-' + row.type ]\">info</mat-icon>\n              <div>\n                <div *ngFor=\"let message of row.messages\" class=\"messages smaller\">\n                  {{ message }}\n                </div>\n              </div>\n            </div>\n          </ng-template>\n        </fs-list-column>\n      </fs-list>\n    </div>\n\n    <p>\n      <ng-template\n        [ngTemplateOutlet]=\"resultTemplate\">\n      </ng-template>\n    </p>\n  </div>\n\n  <div class=\"progress-container\" *ngIf=\"mode === ImportMode.Processing\">\n    <div class=\"progress\">\n      <span>Processing Import</span>\n      <mat-spinner diameter=\"40\"></mat-spinner>\n    </div>\n  </div>\n</div>\n", styles: ["div[hidden]{display:none}::ng-deep fs-message>div{margin-bottom:20px}.progress-container{width:100%;display:flex;flex-direction:row;flex:1;justify-content:center}.progress-container .progress{display:flex;flex-direction:column;align-items:center}.progress-container .progress mat-spinner{margin-top:16px}mat-icon.required{color:#34bd43}.smaller{font-size:85%;color:#636363}.resason{flex-direction:row;display:flex;align-items:center}.resason .icon-message{margin-right:5px}.resason .icon-message.icon-message-fail{color:#fa7567}.resason .icon-message.icon-message-duplicate{color:#3ab7fb}\n"], components: [{ type: i3.FsListComponent, selector: "fs-list", inputs: ["config", "loaderLines"], outputs: ["filtersReady"] }, { type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i2.FsMessageComponent, selector: "fs-message", inputs: ["type", "message", "fsType", "fsMessage"] }, { type: i5.MatSpinner, selector: "mat-spinner", inputs: ["color"] }], directives: [{ type: i6.FsSkeletonContentDirective, selector: "[fsSkeleton]", inputs: ["fsSkeleton", "fsSkeletonPattern"] }, { type: i7.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.FsListColumnDirective, selector: "fs-list-column", inputs: ["title", "name", "show", "customize", "sortable", "sortableDefault", "direction", "align", "width", "class"] }, { type: i3.FsListHeaderDirective, selector: "[fs-list-header]", inputs: ["colspan", "align", "class"] }, { type: i3.FsListCellDirective, selector: "[fs-list-cell]", inputs: ["colspan", "align", "class"] }, { type: i7.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i7.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i7.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "keys": KeysPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsImportComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-import',
                    templateUrl: './import.component.html',
                    styleUrls: ['./import.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: FsImportService }, { type: i2.FsMessage }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { config: [{
                type: Input
            }], hidePreviewColumn: [{
                type: Input
            }], listConfigEl: [{
                type: ViewChild,
                args: ['listConfigEl', { static: true }]
            }], listResultEl: [{
                type: ViewChild,
                args: ['listResultEl', { static: true }]
            }], configTemplate: [{
                type: ContentChild,
                args: [FsImportConfigFooterDirective, { read: TemplateRef }]
            }], resultTemplate: [{
                type: ContentChild,
                args: [FsImportResultFooterDirective, { read: TemplateRef }]
            }] } });

class FsImportModule {
    static forRoot() {
        return {
            ngModule: FsImportModule,
            providers: [FsImportService]
        };
    }
}
FsImportModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsImportModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FsImportModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsImportModule, declarations: [FsImportComponent,
        FsImportConfigFooterDirective,
        FsImportResultFooterDirective,
        KeysPipe], imports: [CommonModule,
        FsListModule,
        FsMessageModule,
        MatIconModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        FsSkeletonModule], exports: [FsImportComponent,
        FsImportConfigFooterDirective,
        FsImportResultFooterDirective] });
FsImportModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsImportModule, providers: [
        FsImportService
    ], imports: [[
            CommonModule,
            FsListModule,
            FsMessageModule,
            MatIconModule,
            MatTooltipModule,
            MatProgressSpinnerModule,
            FsSkeletonModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsImportModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FsListModule,
                        FsMessageModule,
                        MatIconModule,
                        MatTooltipModule,
                        MatProgressSpinnerModule,
                        FsSkeletonModule
                    ],
                    exports: [
                        FsImportComponent,
                        FsImportConfigFooterDirective,
                        FsImportResultFooterDirective
                    ],
                    entryComponents: [],
                    declarations: [
                        FsImportComponent,
                        FsImportConfigFooterDirective,
                        FsImportResultFooterDirective,
                        KeysPipe
                    ],
                    providers: [
                        FsImportService
                    ],
                }]
        }] });

/*
 * Public API Surface of fs-menu
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FsImportComponent, FsImportConfigFooterDirective, FsImportModule, FsImportResultFooterDirective, FsImportService, ImportMode };
